import React from "react";
import "./style.css";
import { ClipLoader } from "react-spinners";

const LoaderAHSF = (props) => {
  return (
    <>
      {props.show && (
        <div className="loader-container_">
          <ClipLoader
            color="#43739D"
            size={100}
            speedMultiplier={0.7}
          />
        </div>
      )}
    </>
  );
};

export default LoaderAHSF;
